
export default {
  props: { context: { type: null, required: true } },
};
